import configpage from "../../Images/Configuration page.jpg";
import list from "../../Images/Added sytem list.jpg";
import addsystem from "../../Images/addsystem.jpg";
import agentfile from "../../Images/agent file Downloaded file.jpg";
import agentinstallerfile from "../../Images/agent installer file.jpg";
import agentlogs from "../../Images/agent logs.jpg";
import agentmanagerwindow from "../../Images/agent Manager window.jpg";
import agentagreement from "../../Images/Agent_agrement.jpg";
import managermenu from "../../Images/manager menu options( start,stop).jpg";

const ConfigurationContent = () => {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-3xl font-semibold text-blue-800 mb-6">
        Configuration
      </h1>
      <b>Creating a Key Using Available License on the Configuration Page</b>
      <ul className="flex flex-col gap-4  list-disc ml-6">
        <li>Navigate to the Configuration Page</li>
        <li>
          Once logged in, locate the Main Navigation Bar at the top of the
          dashboard.
        </li>
        <li>
          Click on the Configuration option from the navigation bar, which will
          take you to the system's configuration settings
        </li>
        <img src={configpage} className="size-2/3" />
        <li>
          To add a new system in SecurWeave HIDS, go to the Configuration page,
          click on Add New System, and fill in the required details such as
          Name, IP Address, Group, and Location. After entering the information,
          click Add to register the new system for monitoring.
        </li>
        <img src={addsystem} className="size-2/3" />
        <li>
          The newly added system, such as system-1, is now listed with its
          information and is ready for monitoring.
        </li>
        <img src={list} className="size-2/3" />
        <li>Use the Key generated during the system registration process.</li>
        <li>
          Download the HIDS agent for your operating system (Windows, Linux,
          etc.) from the SecurWeave website or dashboard.
        </li>
      </ul>
      <b>HIDS Agent Installation Guide</b>
      <p>
        The HIDS agent is a lightweight monitoring software designed for
        security visibility across various platforms, including laptops,
        desktops, servers, cloud instances, containers, and virtual machines. It
        collects critical system and application records, inventory data, and
        detects anomalies to enhance endpoint security.
      </p>
      <p>
        If the central components are already installed in your environment,
        follow the installation steps for your operating system below:
      </p>
      <b>Supported Platforms</b>
      <ul className="flex flex-col gap-4  list-decimal ml-6">
        <li>Windows</li>
        <li>Linux</li>
        <li>Server (Windows/Linux)</li>
        <li>Docker container</li>
      </ul>
      <hr />
      <b>Windows Installation Steps:</b>
      <b>Step 1: Download the HIDS Agent</b>
      <p>Download the HIDS agent installer from the official source:</p>
      <p className="ml-6 text-blue-500">
        <a href="https://packages.wazuh.com/4.x/windows/wazuh-agent-4.4.1-1.msi">
          https://packages.wazuh.com/4.x/windows/wazuh-agent-4.4.1-1.msi
        </a>
      </p>
      <b>Step 2: Locate and Run the Installer</b>
      <ul className="flex flex-col gap-4  list-disc ml-6">
        <li>Navigate to the Downloads folder.</li>
        <li>
          Locate the downloaded <span className="text-red-500">.msi</span> file.
        </li>
        <li>Double-click the installer to run it.</li>
      </ul>
      <b> Step 3: Accept the Installation Agreement</b>
      <ul className="flex flex-col gap-4  list-disc ml-6">
        <li> Select the checkbox to accept the agreement.</li>
        <li>Click Install to proceed.</li>
      </ul>
      <img src={agentagreement} className="size-2/3" />
      <b>Step 4: Locate the Configuration File</b>
      <p>After installation, the configuration file is located at:</p>
      <p className="ml-6 text-blue-500">
        C:\Program Files (x86)\ossec-agent\ossec.conf
      </p>
      <img src={agentfile} className="size-2/3" />
      <b>Step 5: Configure the Agent</b>
      <ul className="flex flex-col gap-4  list-disc ml-6">
        <li>Open the ossec-agent application.</li>
        <li>
          Scroll through the files and locate
          <span className="text-red-500">win32ui</span>.
        </li>
        <li>
          Right-click on <span className="text-red-500">win32ui </span>and
          select <span className="text-red-500">Run as Administrator.</span>
        </li>
      </ul>
      <img src={agentinstallerfile} className="size-2/3" />
      <b>Step 6: Enter Manager IP and Key</b>
      <ul className="flex flex-col gap-4  list-disc ml-6">
        <li>
          Enter the Manager IP and the Key (generated during HIDS
          configuration).
        </li>
        <li>Verify that the displayed agent details are correct.</li>
        <li>Click Save to store the configuration.</li>
      </ul>
      <img src={agentmanagerwindow} className="size-2/3" />
      <b>Step 7: Start the Agent</b>
      <ul className="flex flex-col gap-4  list-disc ml-6">
        <li>Go to the Manage section.</li>
        <li>Click Start Agent to initiate the service.</li>
      </ul>
      <img src={managermenu} className="size-2/3" />
      <b>Step 8: Verify Agent Logs</b>
      <ul className="flex flex-col gap-4  list-disc ml-6">
        <li>Click View Logs to check the status.</li>
        <li>This will open Notepad with the log details.</li>
        <li>Review the logs to ensure the agent is running correctly.</li>
      </ul>
      <img src={agentlogs} className="size-2/3" />
      <hr />
      <p>
        Following these steps ensures a successful installation and
        configuration of the HIDS agent on a Windows system.check agent is
        active or disconnected using Dashboard and report from Reports pages.
      </p>
      <b> Linux Installation Steps</b>
      
      <b>Using .deb Package</b>
      <p>
        &gt; &nbsp; <code>cd deb_installer/</code>
      </p>
      <p>
        &gt; &nbsp; <code>sudo ./deb_installer.sh</code>
      </p>
      
      <b>Step 3: Verify Logs</b>
      <p>Check logs using:</p>
      <p>
        &gt; &nbsp; <code>cat /var/log/syslog</code>
      </p>
      <b>Docker Installation Steps</b>
      <b>Step 1: Install Dependencies</b>
      <p>
        &gt; &nbsp; <code>apt update</code>
      </p>
      <p>
        &gt; &nbsp; <code>apt-get install curl gpg nano</code>
      </p>
      <b>Step 2: Add Wazuh Repository</b>
      <p>
        &gt; &nbsp;
        <code>
          curl -s https://packages.wazuh.com/key/GPG-KEY-WAZUH | gpg
          --no-default-keyring --keyring
          gnupg-ring:/usr/share/keyrings/wazuh.gpg --import && chmod 644
          /usr/share/keyrings/wazuh.gpg
        </code>
      </p>
      <p>
        &gt; &nbsp;
        <code>
          echo "deb [signed-by=/usr/share/keyrings/wazuh.gpg]
          https://packages.wazuh.com/4.x/apt/ stable main" | tee -a
          /etc/apt/sources.list.d/wazuh.list
        </code>
      </p>
      <b>Step 3: Install Wazuh Agent</b>
      <p>
        &gt; &nbsp; <code>apt-get update</code>
      </p>
      <p>
        &gt; &nbsp; <code>apt-get install wazuh-agent=4.6.0-1 -y</code>
      </p>
      <b>Step 4: Configure Wazuh Agent</b>
      <p>Open the configuration file</p>
      <p>
        &gt; &nbsp; <code>nano /var/ossec/etc/ossec.conf</code>
      </p>
      <p>
        Modify the manager section to include your Wazuh manager's IP address.
      </p>
      <b>Step 5: Enable Docker Listener</b>
      <p>Add the following configuration in /var/ossec/etc/ossec.conf</p>
      <code>&lt;wodle name="docker-listener"&gt;</code>
      <code className="ml-6">&lt;disabled&gt;no&lt;/disabled&gt;</code>
      <code>&lt;/wodle&gt;</code>
      <b>Step 6: Install Docker Integration Requirements</b>
      <p>
        &gt; &nbsp;
        <code>
          pip3 install docker==7.1.0 urllib3==1.26.20 requests==2.32.2
        </code>
      </p>
      <b>Step 7: Register the Agent</b>
      <p>
        &gt; &nbsp; <code>cd /var/ossec/bin</code>
      </p>
      <p>
        &gt; &nbsp; <code>./manage_agents</code>
      </p>
      <ul className="flex flex-col gap-4  list-disc ml-6">
        <li>
          Select (I) Insert to enter the key generated from the Wazuh manager.
        </li>
        <li>Confirm installation by pressing Y.</li>
        <li>Exit the agent manager.</li>
      </ul>
      <b>Step 8: Start the Wazuh Agent</b>
      <p>
        &gt; &nbsp; <code>./wazuh-control start</code>
      </p>
      <p>Use stop/restart as needed:</p>
      <p>
        &gt; &nbsp; <code>./wazuh-control stop</code>
      </p>
      <p>
        &gt; &nbsp; <code>./wazuh-control restart</code>
      </p>
      
      <hr />
      <p>
        Following these steps ensures a successful installation and
        configuration of the HIDS agent across different platforms.
      </p>
    </div>
  );
};

export default ConfigurationContent;
